import type { ReactNode } from 'react';
import {
  ComputerScreen,
  LibraryIcon,
  // OKVideo,
  Rutube,
  Smartphone,
  VKVideo,
  Youtube,
} from '@shared/assets/index.ts';
import type { VideoType } from '@shared/types/common';

type VideoSourcesObject = {
  icon: ReactNode;
  text: string;
  videoType: VideoType;
};

export const getVideoSources = (isMobile?: boolean, isCanAddFromLibrary?: boolean) => {
  const output = [
    {
      icon: isMobile ? <Smartphone /> : <ComputerScreen />,
      text: isMobile ? 'Галерея' : 'Компьютер',
      videoType: 'B',
    },
    { icon: <Youtube />, text: 'YouTube', videoType: 'Y' },
    { icon: <Rutube />, text: 'RuTube', videoType: 'R' },
    { icon: <VKVideo />, text: 'VK Video', videoType: 'V' },
    // { icon: <OKVideo />, text: 'Одноклассники', videoType: 'O' },
  ];

  isCanAddFromLibrary &&
    output.unshift({ icon: <LibraryIcon />, text: 'Библиотека', videoType: 'L' });

  return output as VideoSourcesObject[];
};
